export default "__VITE_ASSET__DJeYV4HU__"